(function () {
function createDaisyDiffuserAddGuard(win) {
  var name = 'dm_diffuser_add_v2';
  var owner = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  var held = false, timer, expires = 0;
  function read() {
    try {
      var pair = String(win.document.cookie || '').split(/;\s*/).find(function (part) { return part.indexOf(name + '=') === 0; });
      var value = pair ? decodeURIComponent(pair.slice(name.length + 1)).split('|') : [];
      return value.length === 2 && Number(value[1]) > Date.now() ? { owner: value[0], expires: Number(value[1]) } : null;
    } catch (_) { return null; }
  }
  function write() {
    expires = Date.now() + 120000;
    try { win.document.cookie = name + '=' + encodeURIComponent(owner + '|' + expires) + '; Max-Age=120; Path=/; SameSite=Lax; Secure'; } catch (_) {}
  }
  function pause() { win.clearTimeout(timer); }
  function renew() {
    pause();
    if (!held) return;
    var current = read();
    if (current && current.owner !== owner) { held = false; return; }
    write();
    timer = win.setTimeout(renew, 30000);
    if (timer && typeof timer.unref === 'function') timer.unref();
  }
  function acquire() {
    if (held || read()) return false;
    write();
    var current = read();
    if (current && current.owner !== owner) return false;
    held = true;
    renew();
    return true;
  }
  function release() {
    pause();
    var current = read();
    if (current && current.owner === owner) {
      try { win.document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure'; } catch (_) {}
    }
    held = false;
  }
  win.addEventListener('pagehide', pause);
  return { busy: function () { if (held && expires <= Date.now()) held = false; return held || !!read(); }, acquire: acquire, release: release, pause: pause, resume: renew };
}

(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) { root.DaisyMatchingGift = api; api.boot(root); }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var cookieName = 'dm_matching_gift_v1';
  var rootWindow;
  var signProducts = [9702132711763, 10834441535827];
  var giftVariant = 54863634268499;
  var knownDiffusers = [54440025915731, 54858255335763, giftVariant];

  function readSession() {
    try {
      var pair = rootWindow.document.cookie.split('; ').find(function (part) { return part.indexOf(cookieName + '=') === 0; });
      return pair ? decodeURIComponent(pair.slice(cookieName.length + 1)) : '';
    } catch (_) { return 'unavailable'; }
  }
  function writeSession(value) {
    try { rootWindow.document.cookie = cookieName + '=' + encodeURIComponent(value) + '; Path=/; SameSite=Lax; Secure'; } catch (_) { /* An offer must never block sign purchase. */ }
    return readSession() === value;
  }
  function stage(bundleId) {
    try {
      writeSession('pending:' + bundleId);
    } catch (_) { /* Fail closed if session storage is unavailable. */ }
  }
  function matchPersonalisation(properties) {
    properties = properties || {};
    var first = String(properties['Line 1'] || '').trim();
    var match = first.match(/^(MR\.?|MRS\.?)\s*(?:&|AND)\s*(MR\.?|MRS\.?)\s+(.+)$/i);
    if (!match) return null;
    var titles = [match[1], match[2]].map(function (s) { return s.replace('.', '').toLowerCase() === 'mrs' ? 'Mrs' : 'Mr'; });
    var title = titles.join(' & ');
    if (['Mr & Mrs', 'Mrs & Mrs', 'Mr & Mr'].indexOf(title) < 0) return null;
    var surname = match[3].trim();
    // First names joined with &/AND, dates, and instructions aren't safe surname guesses.
    if (!/^[\p{L}\p{M}'’ .-]+$/u.test(surname) || /\bAND\b/i.test(surname) || surname.length > 80) return null;
    var second = String(properties['Line 2'] || '').trim();
    var date = second.match(/^FROM THIS DAY FORWARD\s*[-–—:]\s*(\d{1,2}[./-]\d{1,2}[./-]\d{2,4})$/i);
    if (date) second = date[1];
    if (second.length > 80) return null;
    return { title: title, surname: surname, line: second, colour: 'White' };
  }
  function personalisationForConfirmation(properties) {
    properties = properties || {};
    var first = String(properties['Line 1'] || '').trim();
    var title = /^MRS\.?\s*(?:&|AND)\s*MRS\.?\b/i.test(first) ? 'Mrs & Mrs' :
      /^MR\.?\s*(?:&|AND)\s*MR\.?\b/i.test(first) ? 'Mr & Mr' : 'Mr & Mrs';
    var line = String(properties['Line 2'] || '').trim();
    var date = line.match(/^FROM THIS DAY FORWARD\s*[-–—:]\s*(\d{1,2}[./-]\d{1,2}[./-]\d{2,4})$/i);
    if (date) line = date[1];
    return { title: title, surname: '', line: line.length <= 80 ? line : '', colour: 'White' };
  }
  function isDiffuser(item) {
    return knownDiffusers.indexOf(Number(item.variant_id || item.id)) >= 0 ||
      /reed.?diffuser/i.test(item.product_type || '') || /reed-diffuser/.test(item.handle || '') ||
      (item.item_components || []).some(isDiffuser);
  }
  function qualifyingSign(cart, bundleId) {
    if (!cart || cart.currency !== 'GBP' || (cart.items || []).some(isDiffuser)) return null;
    return (cart.items || []).find(function (item) {
      var p = item.properties || {};
      return item.quantity > 0 && signProducts.indexOf(Number(item.product_id)) >= 0 && typeof p['_Bundle ID'] === 'string' && p['_Bundle ID'].trim() && (!bundleId || p['_Bundle ID'] === bundleId) && p.Offer !== 'Second sign';
    }) || null;
  }
  function giftItem(details, bundleId) {
    if (['Mr & Mrs', 'Mrs & Mrs', 'Mr & Mr'].indexOf(details.title) < 0 || !details.surname.trim() || details.surname.length > 80 || details.line.length > 80 || ['Black', 'White'].indexOf(details.colour) < 0) throw new Error('Please check the diffuser wording.');
    return { id: giftVariant, quantity: 1, properties: {
      Title: details.title, 'Line 1': details.surname.trim(), 'Line 2': details.line.trim(),
      'Tag colour': details.colour + ' tag', Size: '200ml', 'Gift box': 'Included',
      '_Bundle ID': 'matching-gift-' + bundleId, '_Matching sign': bundleId,
      '_Custom option flow': 'Daisy matching boxed diffuser offer'
    } };
  }

  function boot(win) {
    rootWindow = win;
    var doc = win.document;
    if (!doc || doc.__daisyMatchingGiftBooted) return;
    doc.__daisyMatchingGiftBooted = true;
    var card, form, config, add, dismiss, edit, fields, error, guard, cartCheck, submitter;
    var active = false, dismissed = false, checking = false, selectedBundle = '', boundCard, queued = false, reviewRequired = false;
    var saved = {}, keys = ['title', 'surname', 'line', 'colour'];
    var root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    function readCart() {
      return win.fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('We could not check your basket. Please try again.');
        return r.json();
      });
    }
    function hide() {
      if (card) card.hidden = true;
      doc.body.classList.remove('dm-matching-gift-active');
    }
    function values() {
      var result = {};
      keys.forEach(function (key) { result[key] = form.elements.namedItem(key).value; });
      return result;
    }
    function preview() {
      var current = values();
      saved[selectedBundle] = current;
      form.querySelector('[data-gift-wording]').textContent = current.surname.trim() ? [current.title, current.surname, current.line].filter(Boolean).join('\n') : 'Enter their surname below';
      form.querySelector('[data-gift-colour]').textContent = current.colour + ' tag';
    }
    function showError(message) { error.textContent = message; error.hidden = false; }
    function disable(busy) {
      add.disabled = dismiss.disabled = edit.disabled = busy;
      keys.forEach(function (key) { form.elements.namedItem(key).disabled = busy; });
    }
    function bind() {
      form.addEventListener('input', preview);
      form.addEventListener('change', preview);
      edit.addEventListener('click', function () {
        if (active) return;
        if (!fields.hidden && !form.elements.namedItem('surname').value.trim()) { form.elements.namedItem('surname').focus(); return; }
        fields.hidden = !fields.hidden;
        edit.setAttribute('aria-expanded', String(!fields.hidden));
        edit.textContent = fields.hidden ? 'Edit' : 'Done';
        if (!fields.hidden) form.elements.namedItem('surname').focus();
      });
      dismiss.addEventListener('click', function () { if (!active) { dismissed = true; hide(); } });
      submitter = win.DaisyCartSubmit.create({ root: root, fetch: win.fetch.bind(win) });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (active || dismissed || card.hidden) return;
        var item, bundle = selectedBundle;
        try { item = giftItem(values(), bundle); } catch (e) {
          fields.hidden = false; edit.setAttribute('aria-expanded', 'true'); edit.textContent = 'Done';
          showError(e.message); form.elements.namedItem('surname').focus(); return;
        }
        if (!guard.acquire()) { showError('Another diffuser is being added. Please check your basket in a moment.'); return; }
        active = true; disable(true); error.hidden = true;
        add.textContent = 'Adding your boxed gift…';
        readCart().then(function (cart) {
          if (!qualifyingSign(cart, bundle)) { guard.release(); active = false; hide(); return null; }
          return win.fetch(root + 'products/matching-mr-mrs-diffuser-with-gift-box-sign-offer.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
            if (!r.ok) throw new Error('This offer is currently unavailable. Your sign is still in the basket.');
            return r.json();
          }).then(function (product) {
            var variant = product.variants.find(function (v) { return Number(v.id) === giftVariant; });
            if (!variant || !variant.available || variant.price !== 1999) throw new Error('This offer has changed. Your sign is still in the basket.');
            return submitter.add([item], function () { add.textContent = 'Still checking your basket…'; });
          });
        }).then(function (result) {
          if (!result) return;
          guard.release(); active = false; hide(); win.location.href = config.cartUrl;
        }).catch(function (e) {
          showError(e.message || 'The gift could not be added. Your sign is still in the basket.');
          if (e.reviewCart) {
            reviewRequired = true;
            guard.pause();
            var review = doc.createElement('a'); review.href = config.cartUrl; review.textContent = 'Review basket'; error.appendChild(doc.createTextNode(' ')); error.appendChild(review);
            add.textContent = 'Please review your basket'; return;
          }
          guard.release(); active = false; disable(false); add.textContent = 'Add boxed diffuser — £19.99';
        });
      });
    }
    function show(sign, candidate) {
      var bundle = sign.properties['_Bundle ID'];
      var changed = candidate !== boundCard || bundle !== selectedBundle;
      if (card && card !== candidate) card.hidden = true;
      card = candidate;
      if (changed) {
        config = JSON.parse(card.querySelector('[data-gift-config]').textContent);
        if (Number(config.variant) !== giftVariant || config.price !== 1999 || config.currency !== 'GBP') { hide(); return; }
        form = card.querySelector('[data-gift-form]');
        add = form.querySelector('[data-gift-add]'); dismiss = form.querySelector('[data-gift-dismiss]'); edit = form.querySelector('[data-gift-edit]');
        fields = form.querySelector('#dm-gift-fields'); error = form.querySelector('[data-gift-error]');
        var matched = matchPersonalisation(sign.properties);
        var details = saved[bundle] || matched || personalisationForConfirmation(sign.properties);
        selectedBundle = bundle;
        keys.forEach(function (key) { form.elements.namedItem(key).value = details[key]; });
        fields.hidden = !!details.surname.trim();
        edit.setAttribute('aria-expanded', String(!fields.hidden)); edit.textContent = fields.hidden ? 'Edit' : 'Done';
        if (!matched && !saved[bundle]) {
          form.querySelector('.dm-matching-gift__label').textContent = 'Confirm your diffuser wording';
          card.querySelector('.dm-matching-gift__deal-note').textContent = 'Both included. Personalise your diffuser below.';
          card.querySelector('.dm-matching-gift__footnote').textContent = 'Enter the surname for your diffuser, check the details, then add your boxed gift.';
        }
        if (boundCard !== card) { bind(); boundCard = card; }
        error.hidden = true;
        preview();
      }
      disable(false); add.textContent = 'Add boxed diffuser — £19.99';
      card.hidden = false; doc.body.classList.add('dm-matching-gift-active');
    }
    function refresh(newVisit) {
      if (newVisit) {
        dismissed = false;
        if (active && !reviewRequired && guard) guard.resume();
        if (reviewRequired) {
          active = false; reviewRequired = false;
          guard = createDaisyDiffuserAddGuard(win);
          submitter = win.DaisyCartSubmit.create({ root: root, fetch: win.fetch.bind(win) });
        }
      }
      if (active) return;
      if (dismissed) { hide(); return; }
      var candidate = doc.getElementById('dm-matching-gift');
      if (!candidate || !win.DaisyCartSubmit || typeof win.fetch !== 'function') { hide(); return; }
      if (!guard) guard = createDaisyDiffuserAddGuard(win);
      if (guard.busy()) {
        hide(); win.clearTimeout(cartCheck); cartCheck = win.setTimeout(function () { refresh(false); }, 2000); return;
      }
      if (checking) { queued = true; return; }
      checking = true;
      readCart().then(function (cart) {
        if (active || dismissed || !candidate.isConnected) return;
        var pending = readSession();
        var preferred = pending.indexOf('pending:') === 0 ? pending.slice(8) : selectedBundle;
        var sign = (preferred && qualifyingSign(cart, preferred)) || qualifyingSign(cart);
        if (!sign || guard.busy()) { hide(); return; }
        show(sign, candidate);
      }).catch(hide).then(function () {
        checking = false;
        if (queued) { queued = false; refresh(false); }
      });
    }
    function start() {
      if (!doc.getElementById('dm-matching-gift')) return;
      refresh(false);
      if (win.MutationObserver) new win.MutationObserver(function (records) {
        if (active || dismissed) return;
        var changed = (card && !card.isConnected) || records.some(function (record) {
          var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return node && node.closest('#main-cart-items');
        });
        if (changed) { win.clearTimeout(cartCheck); cartCheck = win.setTimeout(function () { refresh(false); }, 200); }
      }).observe(doc.body, { childList: true, subtree: true });
      win.addEventListener('pageshow', function (event) { if (event.persisted) { hide(); refresh(true); } });
      win.addEventListener('focus', function () { refresh(false); });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  }
  return { stage: stage, boot: boot, matchPersonalisation: matchPersonalisation, personalisationForConfirmation: personalisationForConfirmation, qualifyingSign: qualifyingSign, giftItem: giftItem, isDiffuser: isDiffuser, createAddGuard: createDaisyDiffuserAddGuard };
});

/* Append-only occasion offer: the existing DaisyMatchingGift module stays intact. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports.DaisyOccasionGift = api;
  if (root && root.document) { root.DaisyOccasionGift = api; api.boot(root); }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  // Display frequency is visit-local; legacy occasion cookies are ignored.
  var kinds = ['difffamily', 'difffriend', 'diffxmas'];
  var excludedProducts = [9702132711763, 10834441535827, 10743147692371, 10833681088851, 10833681121619, 10833681187155, 10838792175955];
  var excludedVariants = [54440025915731, 54858255335763, 54863634268499, 54858250223955, 54858250256723, 54858250289491, 54881727414611];
  function numberId(value) { return Number.isSafeInteger(Number(value)) && Number(value) > 0; }
  function validOffer(offer) {
    return !!(offer && kinds.indexOf(offer.kind) >= 0 && numberId(offer.productId) && numberId(offer.variantId) &&
      offer.available === true && Number(offer.price) === 1495 && /^[a-z0-9][a-z0-9-]*$/.test(offer.handle || '') &&
      Array.isArray(offer.colours) && offer.colours.length === 2 &&
      offer.colours.join('|') === (offer.kind === 'diffxmas' ? 'Red|Green' : 'Black|White') &&
      Array.isArray(offer.fields) && offer.fields.length === 3);
  }
  function validBox(box) { return !!(box && box.available === true && numberId(box.variantId) && Number(box.price) === 595 && /^[a-z0-9][a-z0-9-]*$/.test(box.handle || '')); }
  function blocksOffer(item, config) {
    if (!item || Number(item.quantity) <= 0) return false;
    var productId = Number(item.product_id), variantId = Number(item.variant_id || item.id);
    var configured = Object.keys((config && config.offers) || {}).some(function (kind) {
      var offer = config.offers[kind];
      return offer && (Number(offer.productId) === productId || Number(offer.variantId) === variantId);
    });
    return configured || excludedProducts.indexOf(productId) >= 0 || excludedVariants.indexOf(variantId) >= 0 ||
      /(?:reed[-_ ]?diffuser|diffuser[-_ ]?tag)/i.test(item.handle || '') ||
      /reed.?diffuser|diffuser.?tag/i.test(item.product_type || '') ||
      (item.item_components || []).some(function (child) { return blocksOffer(Object.assign({ quantity: item.quantity }, child), config); });
  }
  function eligible(cart, config) {
    if (!cart || !config || cart.currency !== 'GBP' || config.currency !== 'GBP' || !Array.isArray(cart.items) || cart.items.some(function (item) { return blocksOffer(item, config); })) return null;
    var candidates = [];
    cart.items.forEach(function (item) {
      if (!(Number(item.quantity) > 0) || !numberId(item.product_id)) return;
      var key = String(item.product_id);
      if (!config.mapping || !Object.prototype.hasOwnProperty.call(config.mapping, key)) return;
      var kind = config.mapping[key], offer = config.offers && config.offers[kind];
      if (kinds.indexOf(kind) < 0 || !validOffer(offer) || offer.kind !== kind) return;
      candidates.push({ kind: kind, source: item, offer: offer });
    });
    return candidates.find(function (candidate) { return candidate.kind === 'diffxmas'; }) || candidates[0] || null;
  }
  function validate(details, offer, box) {
    if (!validOffer(offer)) throw new Error('This diffuser is currently unavailable. Please refresh your basket.');
    if (!details || offer.colours.indexOf(details.colour) < 0) throw new Error('Please choose a tag colour.');
    var lines = [details.line1, details.line2, details.line3].map(function (line) { return String(line == null ? '' : line).trim(); });
    lines.forEach(function (line, index) {
      if (line.length > 80) throw new Error('Please keep line ' + (index + 1) + ' to 80 characters.');
      // Requirements belong to the design, so malformed config cannot skip them.
      var required = index === 0 || (index === 1 && offer.kind !== 'difffriend');
      if (required && !line) throw new Error('Please enter line ' + (index + 1) + ' for your diffuser.');
    });
    if (details.giftbox && !validBox(box)) throw new Error('The gift box is currently unavailable. Please untick the gift box to continue.');
    return { colour: details.colour, line1: lines[0], line2: lines[1], line3: lines[2], giftbox: details.giftbox === true };
  }
  function buildItems(details, offer, box, source, bundleId) {
    var checked = validate(details, offer, box);
    if (!source || !numberId(source.product_id) || typeof bundleId !== 'string' || !bundleId.trim()) throw new Error('Please refresh your basket before adding this diffuser.');
    var properties = {
      'Tag colour': checked.colour + ' tag', 'Line 1': checked.line1, 'Line 2': checked.line2, 'Line 3': checked.line3,
      Size: '200ml', '_Bundle ID': bundleId, '_Custom option flow': 'Daisy occasion diffuser offer', '_Matching gift source': String(source.product_id)
    };
    var items = [{ id: Number(offer.variantId), quantity: 1, properties: properties }];
    if (checked.giftbox) items.push({ id: Number(box.variantId), quantity: 1, parent_id: Number(offer.variantId), properties: {
      Component: 'Gift box', 'Gift box for': 'Diffuser 1', '_Linked product': String(offer.title || 'Personalised reed diffuser'), '_Bundle ID': bundleId
    } });
    return items;
  }
  function verifyProduct(product, choice, box) {
    if (!(box ? validBox(choice) : validOffer(choice))) return false;
    if (!product || !Array.isArray(product.variants) || (!box && Number(product.id) !== Number(choice.productId))) return false;
    var variant = product.variants.find(function (item) { return Number(item.id) === Number(choice.variantId); });
    return !!(variant && variant.available === true && Number(variant.price) === Number(choice.price));
  }
  function previewText(details) {
    return [1, 2, 3].map(function (line) { return 'Line ' + line + ': ' + (String(details['line' + line] || '').trim() || '(blank)'); }).join('\n');
  }
  function boot(win) {
    var doc = win.document;
    if (!doc || doc.__daisyOccasionGiftBooted) return;
    doc.__daisyOccasionGiftBooted = true;
    var card, binding, config, selected, guard, submitter, observer, cartCheck;
    var dismissed = false, active = false, requestPending = false, reviewRequired = false;
    var refreshVersion = 0, draft = null, draftKey = '', detailsOpen = false;
    var route = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    if (!/^\/(?!\/)[a-zA-Z0-9/_-]*$/.test(route)) route = '/';
    if (route.slice(-1) !== '/') route += '/';
    var cartUrl = route + 'cart';
    function keyFor(match) {
      return match ? match.kind + ':' + String(match.source.product_id) + ':' + String(match.source.key || match.source.variant_id || '') : '';
    }
    function money(pence) { return '£' + (Number(pence) / 100).toFixed(2); }
    function field(name) { return binding && binding.form.elements.namedItem(name); }
    function values() {
      return { colour: field('colour').value, line1: field('line1').value, line2: field('line2').value, line3: field('line3').value, giftbox: field('giftbox').checked };
    }
    function remember() {
      if (!binding || !selected) return;
      draft = values(); draftKey = keyFor(selected); detailsOpen = !binding.details.hidden;
    }
    function hide() { if (card) card.hidden = true; }
    function text(name, value) { var node = card && card.querySelector('[data-occasion-' + name + ']'); if (node) node.textContent = value; }
    function readCart() {
      return win.fetch(route + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('We could not check your basket. Please try again.');
        return response.json();
      });
    }
    function currentSelection(cart) { return keyFor(eligible(cart, config)) === keyFor(selected) && !!selected; }
    function showError(message, review) {
      if (!binding) return;
      binding.error.textContent = message; binding.error.hidden = false;
      if (review) {
        var link = doc.createElement('a'); link.href = cartUrl; link.textContent = 'Review basket';
        binding.error.appendChild(doc.createTextNode(' ')); binding.error.appendChild(link);
      }
    }
    function disable(busy) {
      if (!binding) return;
      binding.add.disabled = busy; binding.dismiss.disabled = busy; binding.open.disabled = busy;
      ['colour', 'line1', 'line2', 'line3'].forEach(function (name) { field(name).disabled = busy; });
      field('giftbox').disabled = busy || !validBox(config.giftBox);
    }
    function renderValues() {
      if (!binding || !selected) return;
      var current = values(), total = Number(selected.offer.price) + (current.giftbox && validBox(config.giftBox) ? Number(config.giftBox.price) : 0);
      text('preview', previewText(current)); text('total', money(total));
      if (!active) binding.add.textContent = 'Add personalised diffuser — ' + money(total);
    }
    function show(match, restore) {
      if (!binding || !match) { hide(); return; }
      var offer = match.offer, nextKey = keyFor(match), priorDraft = restore && draftKey === nextKey ? draft : null;
      selected = match;
      var headings = { difffamily: 'A personal touch for your home', difffriend: 'Your words, a personal touch', diffxmas: 'A festive finishing touch' };
      text('heading', String(offer.headline || headings[match.kind]));
      text('intro', String(offer.intro || 'Personalise a Luxe Fresh reed diffuser for you or someone special.'));
      text('price', money(offer.price));
      text('included', '200ml diffuser, reeds and one personalised tag. Gift box optional.');
      text('source', 'Chosen to go with: ' + String(match.source.product_title || match.source.title || 'your gift'));
      var image = card.querySelector('[data-occasion-image]');
      if (image) {
        var imageUrl = typeof offer.image === 'string' ? offer.image : '';
        if (/^\/\/[a-z0-9.-]+(?::\d+)?\//i.test(imageUrl)) imageUrl = 'https:' + imageUrl;
        if (/^(https:\/\/|\/(?!\/))/.test(imageUrl)) { image.src = imageUrl; image.alt = String(offer.imageAlt || offer.title || 'Personalised reed diffuser'); image.hidden = false; }
        else image.hidden = true;
      }
      var colour = field('colour'); colour.textContent = '';
      offer.colours.forEach(function (name) { var option = doc.createElement('option'); option.value = name; option.textContent = name; colour.appendChild(option); });
      colour.value = priorDraft && offer.colours.indexOf(priorDraft.colour) >= 0 ? priorDraft.colour : offer.colours[0];
      offer.fields.forEach(function (definition, index) {
        var name = 'line' + (index + 1), input = field(name), label = card.querySelector('[data-occasion-label="' + index + '"]');
        input.value = priorDraft ? priorDraft[name] : ''; input.maxLength = 80;
        input.required = index === 0 || (index === 1 && offer.kind !== 'difffriend');
        input.placeholder = String(definition.placeholder || '');
        if (label) {
          var labelText = String(definition.label || 'Line ' + (index + 1));
          label.textContent = labelText + (input.required ? (/\*\s*$/.test(labelText) ? '' : ' *') : (!/\(optional\)/i.test(labelText) ? ' (optional)' : ''));
        }
      });
      field('giftbox').checked = !!(priorDraft && priorDraft.giftbox && validBox(config.giftBox));
      var boxRow = card.querySelector('[data-occasion-box-row]'); if (boxRow) boxRow.hidden = !validBox(config.giftBox);
      text('box-label', validBox(config.giftBox) ? 'Add a gift box — ' + money(config.giftBox.price) : 'Gift box currently unavailable');
      binding.details.hidden = !(priorDraft && detailsOpen); binding.open.setAttribute('aria-expanded', String(!binding.details.hidden));
      binding.error.hidden = true;
      disable(active); renderValues();
      if (active) {
        binding.add.textContent = reviewRequired ? 'Please review your basket' : 'Checking your basket…';
        if (reviewRequired) showError('We could not confirm whether everything was added. Please review your basket before adding again.', true);
      }
      card.hidden = dismissed;
      remember();
    }
    function loadProduct(choice, isBox) {
      return win.fetch(route + 'products/' + choice.handle + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error(isBox ? 'The gift box could not be checked. Please try again.' : 'The diffuser could not be checked. Please try again.');
        return response.json();
      }).then(function (product) {
        if (!verifyProduct(product, choice, isBox)) throw new Error(isBox ? 'The gift box price or availability has changed. Please refresh your basket.' : 'The diffuser price or availability has changed. Please refresh your basket.');
      });
    }
    function submit(event) {
      event.preventDefault();
      if (active || dismissed || !selected || !binding || card.hidden) return;
      var current = values(), offer = selected.offer, items;
      try { items = buildItems(current, offer, config.giftBox, selected.source, 'occasion-gift-' + Date.now() + '-' + Math.random().toString(36).slice(2)); }
      catch (error) { binding.details.hidden = false; binding.open.setAttribute('aria-expanded', 'true'); showError(error.message); return; }
      if (!guard.acquire()) { showError('Another diffuser is being added. Please review your basket before trying again.', true); return; }
      active = true; requestPending = true; reviewRequired = false; ++refreshVersion;
      disable(true); binding.error.hidden = true; binding.add.textContent = 'Checking your basket…';
      readCart().then(function (freshCart) {
        if (!currentSelection(freshCart)) {
          guard.release(); active = false; requestPending = false; hide(); return null;
        }
        var checks = [loadProduct(offer, false)];
        if (current.giftbox) checks.push(loadProduct(config.giftBox, true));
        return Promise.all(checks).then(function () {
          binding.add.textContent = 'Adding your personalised diffuser…';
          return submitter.add(items, function () { if (binding) binding.add.textContent = 'Still checking your basket…'; });
        });
      }).then(function (result) {
        if (!result) return;
        guard.release(); active = false; requestPending = false; hide(); win.location.href = cartUrl;
      }).catch(function (error) {
        requestPending = false;
        showError(error.message || 'The diffuser could not be added. Please check your basket.', !!error.reviewCart);
        if (error.reviewCart) {
          reviewRequired = true; guard.pause(); binding.add.textContent = 'Please review your basket'; return;
        }
        guard.release(); active = false; disable(false); renderValues();
      });
    }
    function attach(candidate) {
      if (!candidate) { hide(); return false; }
      if (candidate === card && binding) return true;
      remember();
      card = candidate; card.hidden = true; binding = null;
      try {
        config = JSON.parse(card.querySelector('script[data-occasion-config]').textContent);
        if (config.currency !== 'GBP') return false;
        if (typeof config.cartUrl === 'string' && /^\/(?!\/)[a-zA-Z0-9/_-]*cart(?:\?[^#]*)?$/.test(config.cartUrl)) cartUrl = config.cartUrl;
      } catch (_) { return false; }
      if (card.__daisyOccasionBinding) {
        binding = card.__daisyOccasionBinding;
        if (selected) { show(selected, true); if (!active) hide(); }
        return true;
      }
      var form = card.querySelector('[data-occasion-form]');
      var next = { form: form, card: card, error: card.querySelector('[data-occasion-error]'), add: card.querySelector('[data-occasion-add]'), dismiss: card.querySelector('[data-occasion-dismiss]'), open: card.querySelector('[data-occasion-open]'), details: card.querySelector('[data-occasion-details]') };
      if (!form || !next.error || !next.add || !next.dismiss || !next.open || !next.details || ['colour', 'line1', 'line2', 'line3', 'giftbox'].some(function (name) { return !form.elements.namedItem(name); })) return false;
      binding = next;
      card.__daisyOccasionBinding = next;
      // A replaced cart node gets one set of listeners; old detached listeners are inert.
      if (!card.__daisyOccasionBound) {
        card.__daisyOccasionBound = true;
        function isCurrent() { return binding === next && doc.getElementById('dm-occasion-gift') === next.card; }
        form.addEventListener('input', function () { if (isCurrent() && !active) { remember(); renderValues(); } });
        form.addEventListener('change', function () { if (isCurrent() && !active) { remember(); renderValues(); } });
        next.open.addEventListener('click', function () {
          if (!isCurrent() || active || dismissed || !selected) return;
          next.details.hidden = false; next.open.setAttribute('aria-expanded', 'true'); detailsOpen = true; field('line1').focus(); remember();
        });
        next.dismiss.addEventListener('click', function () { if (isCurrent() && !active) { remember(); dismissed = true; hide(); } });
        form.addEventListener('submit', function (event) { if (isCurrent()) submit(event); else event.preventDefault(); });
      }
      if (selected) { show(selected, true); if (!active) hide(); }
      return true;
    }
    function refresh(newVisit) {
      if (newVisit) {
        dismissed = false;
        if (requestPending) guard.resume();
        if (!requestPending) {
          if (reviewRequired) {
            guard.pause(); guard = createDaisyDiffuserAddGuard(win);
            submitter = win.DaisyCartSubmit.create({ root: route, fetch: win.fetch.bind(win) });
          }
          active = false; reviewRequired = false;
        }
      }
      var candidate = doc.getElementById('dm-occasion-gift');
      if (!candidate) { remember(); hide(); return; }
      if (!attach(candidate)) return;
      if (active) return;
      if (dismissed) { win.clearTimeout(cartCheck); hide(); return; }
      if (guard.busy()) { hide(); retryGuard(); return; }
      var version = ++refreshVersion;
      readCart().then(function (freshCart) {
        if (version !== refreshVersion || active || dismissed) return;
        if (doc.getElementById('dm-occasion-gift') !== card || !card.isConnected) { refresh(false); return; }
        var match = eligible(freshCart, config);
        if (!match) { remember(); hide(); return; }
        if (guard.busy()) { remember(); hide(); retryGuard(); return; }
        remember();
        show(match, true);
      }).catch(function () { if (version === refreshVersion && !active) hide(); });
    }
    function retryGuard() {
      win.clearTimeout(cartCheck);
      cartCheck = win.setTimeout(function () { refresh(false); }, 2000);
      if (cartCheck && typeof cartCheck.unref === 'function') cartCheck.unref();
    }
    function scheduleRefresh() {
      win.clearTimeout(cartCheck);
      cartCheck = win.setTimeout(function () { refresh(false); }, 200);
    }
    function start() {
      var candidate = doc.getElementById('dm-occasion-gift');
      if (!candidate) return;
      if (!win.DaisyCartSubmit || typeof win.DaisyCartSubmit.create !== 'function' || typeof win.fetch !== 'function' || typeof createDaisyDiffuserAddGuard !== 'function') { candidate.hidden = true; return; }
      guard = createDaisyDiffuserAddGuard(win);
      submitter = win.DaisyCartSubmit.create({ root: route, fetch: win.fetch.bind(win) });
      refresh(false);
      if (win.MutationObserver) {
        observer = new win.MutationObserver(function (records) {
          var next = doc.getElementById('dm-occasion-gift');
          if (next !== card || card && !card.isConnected) { refresh(false); return; }
          var changedCart = records.some(function (record) {
            var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            return !!(node && !node.closest('#dm-occasion-gift') && node.closest('#main-cart-items'));
          });
          if (changedCart) scheduleRefresh();
        });
        observer.observe(doc.body, { childList: true, subtree: true });
      }
      win.addEventListener('focus', function () { refresh(false); });
      doc.addEventListener('visibilitychange', function () { if (doc.visibilityState !== 'hidden') refresh(false); });
      win.addEventListener('pageshow', function (event) { refresh(!!event.persisted); });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  }
  return { eligible: eligible, buildItems: buildItems, validate: validate, verifyProduct: verifyProduct, previewText: previewText, boot: boot };
});

})();
